import { CssBaseline, ThemeProvider } from "@mui/material";
// import SubCollection from "features/collection/components/SubCollectionScreen/SubCollection";
import ChildHeaderLayout from "layouts/childHeaderLayout";
import MainLayout from "layouts/mainLayout";
import Catalogue from "pages/Catalogue";
import Categories from "pages/Categories";
import Collection from "pages/Collection";
import Settings from "pages/Setting";

import Home from "pages/Home";
import Login from "pages/Login";
import SubCategories from "pages/SubCategories";
import SubCategoriesProd from "pages/SubCategoriesProd";
import { createBrowserRouter } from "react-router-dom";
import customTheme from "thems/loginThems";
import { ReactComponent as CollectionIcon } from "assets/sidebar/enable/collection.svg";

import { ReactComponent as CatalogueIcon } from "assets/sidebar/enable/catalogue.svg";
import { ReactComponent as CategoryIcon } from "assets/sidebar/enable/category.svg";
import { ReactComponent as SetIcon } from "assets/sidebar/enable/sets.svg";
import { ReactComponent as SettingIcon } from "assets/sidebar/enable/setting.svg";
import { ReactComponent as StockIcon } from "assets/sidebar/enable/Stock.svg";
import { ReactComponent as SettingIcon2 } from "assets/sidebar/disable/setting.svg";

// import SubCollectionProduct from "features/collection/components/CollectionProductScreen/SubCollectionProduct";
import Cart from "pages/Cart";
import Sets from "pages/Sets";
import { ReactComponent as Category2 } from "assets/sidebar/disable/category.svg";
import { ReactComponent as Collection2 } from "assets/sidebar/disable/collection.svg";
import { ReactComponent as Catlogue3 } from "assets/icons/disable/Catalog.svg";
import { ReactComponent as Sets2 } from "assets/sidebar/disable/sets.svg";
import { ReactComponent as Stock2 } from "assets/sidebar/disable/Stock.svg";

import CatalogSettingLayout from "../layouts/CatalogSetting/CatalogSettingLayout";
import { CatalogSetting } from "pages/CatalogSetting";
import { CatalogClientActivityScreen } from "features/catalogue/components/Settings/Activity/componets/CatalogClientActivityScreen";
import { CatalogSettingProvider } from "context/CatalogSettingContext";
import CatalogClientReportScreen from "features/catalogue/components/Settings/Report/componet/CatalogClientReportScreen";
import { GlobalProvider } from "context/GlobalContext";
import CatalogReportScreen from "features/catalogue/components/Settings/CatalogReport/componet/CatalogReportScreen";

import Archives from "features/Setting/archive/components/Archives";
import RolePage from "features/Setting/Role/Component/RolePage";
import SetArchives from "features/Setting/archive/components/SetArchives";
import CatalogArchiveScreen from "features/Setting/archive/components/CatalogArchiveScreen";
import CatalogProductArchiveScreen from "features/Setting/archive/components/CatalogProductArchiveScreen";
import { SettingProvider } from "context/SettingContext";
// import RoleDetailPage from "features/Setting/Role/Component/RoleDetailPage";
import UsersScreen from "features/Setting/users/componets/UsersScreen";
import { CreateUserFrom } from "features/Setting/users/componets/CreateUserFrom";
import SortContextProvider from "context/sortContextProvider";
import RightPage from "features/Setting/Rights/RightPage";
import NewRightsPage from "features/Setting/New Rights/NewRightsPage";
import CatalogueDynamic from "features/catalogue/components/CatalogueDynamic";
import MainActivity from "features/Setting/Activity/MainActivity";
import LimitsPage from "features/Setting/Limits/LimitsPage";
import ProtectedRoute from "./ProtectedRoute";
import SettingLayoutOne from "layouts/SettingLayout/SettingLayoutOne";
import Orders from "features/Setting/order/components/Orders";
import OrderDetails from "features/Setting/order/components/OrderDetails";
import { PermissionsProvider } from "context/PermissionsContext";
import CatagoryChildLayoutWraaper from "layouts/CatagoryChildLayoutWraaper";
import SetDesings from "pages/SetDesings";
import SetChildLayoutWrapper from "layouts/SetChildLayoutWrapper";
import CollectionChildLayoutWraaper from "layouts/CollectionChildLayoutWraaper";
import CatalogChildLayoutWraaper from "layouts/CatalogChildLayoutWraaper";
import MissingImages from "features/Setting/Missing_Images/components/MissingImages";

import RestrictedDesignCategoryPage from "features/Setting/Restricted_Design_Page/RestrictedDesignCategoryPage";
import RestrictedDesignSubCategoryPage from "features/Setting/Restricted_Design_Page/RestrictedDesignSubCategoryPage";
import RestrictProductPage from "features/Setting/Restricted_Design_Page/RestrictProductPage/RestrictProductPage";
import SyncPage from "features/Setting/Synchronize/SyncPage";
// import SubCategoryPage from "features/Setting/Synchronize/syncSubCategory/SubCategoryPage";
// import SyncMakeTypePage from "features/Setting/Synchronize/syncMakeType/SyncMakeTypePage";
// import SyncSetsPage from "features/Setting/Synchronize/syncSets/SyncSetsPage";
// import SyncCollectionPage from "features/Setting/Synchronize/syncCollection/SyncCollectionPage";
import Designs from "features/Setting/Design Import/Designs";

// import SyncRestrictPage from "features/Setting/Synchronize/syncRestrictDesign/SyncRestrictPage";
import StockChildLayoutWraaper from "layouts/StockChildLayoutWraaper";
import Stock from "pages/Stock";
import SubStocks from "features/Stock/subcategory/components/SubStocks";
import SubStockProd from "pages/SubStockProd";
import SubStock from "pages/SubStock";
import StockSetProduct from "pages/StocktSetProduct";
import SubStockChildLayoutWraaper from "layouts/SubStockChildLayoutWrapper";
import SubCollectionNew from "features/collection/components/SubCollectionScreen/SubCollectionNew";
import AiCollectionProduct from "features/collection/components/AiCollectionProductScreen/AiCollectionProduct";
import CollectionProductPageDynamic from "features/collection/components/CollectionProductPageDynamic";
// import SyncDesignClassPage from "features/Setting/Synchronize/syncDesignClass/SyncDesignClassPage";
import SubStockSetProduct from "pages/SubStocktSetProduct";
import RateMasterRights from "features/Setting/Rate_Master_Rights/components/RateMasterRights";
import DesignStatus from "features/Setting/Design Import/DesignStatus";
import UpdateImagesPage from "features/Setting/UpdateImages/UpdateImagesPage";
import { FilterProvider } from "context/FilterContext";
import Labour_Rights from "features/Setting/Labour_Rights/Labour_Rights";
import SyncActionTypePage from "features/Setting/Synchronize/SyncActionType/SyncActionTypePage";
import SubStockSetProductItem from "pages/SubStockSetProductItem";
import Product from "features/Category/categoryProd/components/Product";
import ProductUSPAndGallery from "features/Setting/Product_USP_and_Gallery/Product_USP_and_Gallery";
import AddUSPDetails from "features/Setting/Product_USP_and_Gallery/AddUSPDetails";
import EditUSPDetails from "features/Setting/Product_USP_and_Gallery/EditUSPDetails";
import CartOrder from "pages/CartOrder";
import ClientDetails from "pages/ClientDetails";
import OrderPlaceScreen from "components/ui/OrderPlaceScreen";
import MyBinnysAccess from "features/Setting/My_Binnys_Access/My_Binnys_Access";
import ClientsUserDetails from "features/Setting/My_Binnys_Access/clientsUserDetails";
import WabaRights from "features/Setting/Waba_Rights/components/WabaRights";
import StockTray from "features/Setting/StockTray/StockTray";
import EventType from "features/Setting/EventType/EventType";
import ClientReportPage from "features/Setting/My_Binnys_Access/reportPage";
import CollectionProductPageWrapper from "features/collection/components/CollectionProductPageWrapper/CollectionProductPageWrapper";
import Clients from "pages/Clients";
import { ReactComponent as Clients1 } from "assets/icons/Clients_Flow_Icons/ClientsEnableIcon.svg";
import ClientsFlowLayout from "layouts/ClientsFlow/ClientsFlowLayout";
import ClientsCatalog from "pages/ClientsCatalog";
import ClientsPurchases from "pages/ClientsPurchases";
import ClientsDueAndLedger from "pages/ClientsDueAndLedger";
import QuotesOrdersPage from "pages/QuotesOrdersPage";
import WipPage from "pages/WipPage";
import PurchasePageWrapper from "features/clients/Purchase/PurchasePageWrapper";
import PurchaseCategoryPageWrapper from "features/clients/Purchase/PurchaseCategoryPageWrapper";
import PurchaseSubCategoryPageWrapper from "features/clients/Purchase/PurchaseSubCategoryPageWrapper";

import NpdOrdersPage from "pages/NpdOrdersPage";
import DuesAndLedgerDetails from "features/clients/Dues&Ledger/DuesAndLedgerDetails";
import QuotesAndOrdersDynamicPage from "features/clients/quote_order_page/QuotesAndOrdersDynamicPage";
import WipDynamicPage from "features/clients/wip/WipDynamicPage";
import { ClientProvider } from "context/ClientContext";
import { PartialSetsPurchaseDesignPage } from "features/clients/Purchase/Partial Sets/Product/PartialSetsPurchaseDesignPage";
import ClientsCatalogTypeWrapper from "features/clients/Catalog/ClientsCatalogTypeWrapper";
import CatalogSessionScreen from "features/clients/Catalog/CatalogSessionScreen";
import CatalogTypePageWrapper from "features/clients/Catalog/CatalogTypePageWrapper";
// import { CartProvider } from "context/CartContext";
import { Provider } from "react-redux";
import { store } from "store";
import ServiceRequest from "features/Setting/Service Request/ServiceRequest";
import ServiceRequestDetails from "features/Setting/Service Request/ServiceRequestDetails";
import MeltingRequests from "features/Setting/Melting_Requests/components/MeltingRequests";
import MeltingRequestDetail from "features/Setting/Melting_Requests/components/MeltingRequestDetail";
import LimitsSubPage from "features/Setting/Limits/LimitsSubPage";
import ReorderStockViewPage from "components/ui/CreateModal/ReOrderStockViewPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Provider store={store}>
        <ProtectedRoute>
          <PermissionsProvider>
            <GlobalProvider>
              {/* <CartProvider> */}
              <MainLayout />
              {/* </CartProvider> */}
            </GlobalProvider>
          </PermissionsProvider>
        </ProtectedRoute>
      </Provider>
    ),
    children: [
      // {
      //   path: "",
      //   element: <Home />,
      // },
      {
        path: "Catalog",
        element: <ChildHeaderLayout pageName="Catalog" icon={<CatalogueIcon />} deIcon={<Catlogue3 />} />,
        // element: <CatalogChildLayoutWraaper pageName="Catalog" icon={<CatalogueIcon />} deIcon={<Catlogue3 />} />,
        children: [
          {
            path: "",
            element: <Catalogue />,
          },
          {
            path: ":id",
            element: <CatalogueDynamic />,
          },
          {
            path: ":id/Catalog-ReportNew",
            element: <CatalogReportScreen />,
          },
        ],
      },
      {
        path: "reorder-stock-view/:type",
        element: <ChildHeaderLayout pageName="" />,
        children: [
          {
            path: "",
            element: <ReorderStockViewPage />,
          },
        ],
      },

      {
        path: "Category",
        element: <ChildHeaderLayout pageName="Category" icon={<CategoryIcon />} deIcon={<Category2 />} />,
        // element: <CatagoryChildLayoutWraaper pageName="Category" icon={<CategoryIcon />} deIcon={<Category2 />} />,
        children: [
          {
            path: "",
            element: <Categories />,
          },
          {
            path: ":category",
            element: <SubCategories />,
          },
          {
            path: ":category/:subcategory",
            element: <SubCategoriesProd />,
          },
        ],
      },

      {
        path: "Collection",
        element: <ChildHeaderLayout pageName="Collection" icon={<CollectionIcon />} deIcon={<Collection2 />} />,
        // element: <CollectionChildLayoutWraaper pageName="Collection" icon={<CollectionIcon />} deIcon={<Collection2 />} />,

        children: [
          {
            path: "",
            element: <Collection />,
          },
          {
            path: ":collectionName",
            element: <SubCollectionNew />,
          },
          // {
          //   path: ":collectionName/:subcategoryId",
          //   element: <CollectionProductPageDynamic />,
          // },
          {
            path: ":collectionName/:subcategoryId",
            element: <CollectionProductPageWrapper />,
          },
          {
            path: ":collectionName/:subcategoryId/:subCategoryName",
            element: <CollectionProductPageDynamic />,
          },
          // {
          //   path: ":collectionName/:subcategoryId",
          //   element: <SubCollectionProduct />,
          // },
          // {
          //   path: "ai/:aiCollectionName/:aiSubcategoryId",
          //   element: <AiCollectionProduct />,
          // },
        ],
      },
      {
        path: "Cart",
        element: <ChildHeaderLayout pageName="Cart" />,
        children: [
          {
            path: "",
            element: <Cart />,
          },
        ],
      },
      {
        path: "CartOrder",
        element: <ChildHeaderLayout pageName=" " />,
        children: [
          {
            path: "",
            element: <CartOrder />,
          },
        ],
      },
      {
        path: "Client-Details",
        element: <ChildHeaderLayout pageName="Client Details" />,
        children: [
          {
            path: "",
            element: <ClientDetails />,
          },
        ],
      },

      //set
      {
        path: "Sets",
        element: <ChildHeaderLayout pageName="Sets" icon={<SetIcon />} deIcon={<Sets2 />} />,
        // element: <SetChildLayoutWrapper pageName="Sets" icon={<SetIcon />} deIcon={<Sets2 />} />,
        children: [
          {
            path: "",
            element: <Sets />,
          },
          {
            path: ":id",
            element: <SetDesings />,
          },
        ],
      },

      //Stock
      {
        path: "Stock",
        element: <ChildHeaderLayout pageName="Stock" icon={<StockIcon />} deIcon={<Stock2 />} />,
        // element: <StockChildLayoutWraaper pageName="Stock" icon={<StockIcon />} deIcon={<Stock2 />} />,
        children: [
          {
            path: "",
            element: <Stock />,
          },
          {
            path: ":category",
            element: <SubStock />,
          },
          {
            path: ":category/:subcategory",
            element: <SubStockProd />,
          },
          {
            path: ":category/:subcategory/:jewelid",
            element: <SubStockSetProductItem />,
          },
        ],
      },
      {
        path: ":set",
        element: <SubStockChildLayoutWraaper />,
        children: [
          {
            path: ":setid",
            element: <StockSetProduct />,
          },
          {
            path: ":setid/:nsid",
            element: <SubStockSetProduct />,
          },
          {
            path: ":setid/:nsid/:jewelid",
            element: <SubStockSetProductItem />,
          },
        ],
      },

      // Clients
      {
        path: "Clients",
        element: <ChildHeaderLayout pageName="Clients" icon={<Clients1 />} deIcon={<Sets2 />} />,
        children: [
          {
            path: "",
            element: <Clients />,
          },
        ],
      },

      //end
    ],
  },

  {
    path: "/OrderPlaceScreen",
    element: <OrderPlaceScreen />,
  },

  {
    path: "/login",
    element: (
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <Login />
      </ThemeProvider>
    ),
  },

  {
    path: "CatalogSetting",
    element: (
      <Provider store={store}>
        <ProtectedRoute>
          <PermissionsProvider>
            <GlobalProvider>
              <FilterProvider>
                <CatalogSettingProvider>
                  <SortContextProvider>
                    <CatalogSettingLayout />
                  </SortContextProvider>
                </CatalogSettingProvider>
              </FilterProvider>
            </GlobalProvider>
          </PermissionsProvider>
        </ProtectedRoute>
      </Provider>
    ),
    children: [
      {
        path: ":id",                                          
        element: <CatalogSetting />,
      },
      {
        path: "Client-Activity/:id/:catalogClinetId",
        element: <CatalogClientActivityScreen />,
      },
      {
        path: "Client-Report/:id/:catalogClinetId",
        element: <CatalogClientReportScreen />,
      },
      {
        path: "Catalog-Report/:id",
        element: <CatalogReportScreen />,
      },
    ],
  },

  {
    path: "client-flow/:clientId",
    element: (
      <Provider store={store}>
        <ProtectedRoute>
          <PermissionsProvider>
            <FilterProvider>
              <SortContextProvider>
                <CatalogSettingProvider>
                  <GlobalProvider>
                    <ClientProvider>
                      <ClientsFlowLayout pageName="Purchase" />
                    </ClientProvider>
                  </GlobalProvider>
                </CatalogSettingProvider>
              </SortContextProvider>
            </FilterProvider>
          </PermissionsProvider>
        </ProtectedRoute>
      </Provider>
    ),
    children: [
      {
        index: true,
        element: <ClientsPurchases />,
      },
      {
        path: "clients-purchases",
        element: <ClientsPurchases />,
      },
      {
        path: "clients-purchases/:purchase",
        element: <PurchasePageWrapper />,
      },
      {
        path: "clients-purchases/:purchase/:category",
        element: <PurchaseCategoryPageWrapper />,
      },
      {
        path: "clients-purchases/:purchase/:category/:subCategory",
        element: <PurchaseSubCategoryPageWrapper />,
      },

      // --------------------------------------------------
      {
        path: "clients-catalog",
        element: <ClientsCatalog />,
      },
      {
        path: "clients-catalog/:catalogtype",
        element: <ClientsCatalogTypeWrapper />,
      },
      {
        path: "clients-catalog/:catalogtype/:catalogName",
        element: <CatalogTypePageWrapper />,
      },

      // ----------------------------------------------------
      {
        path: "dues-ledger",
        element: <ClientsDueAndLedger />,
      },
      {
        path: "dues-ledger/:check",
        element: <DuesAndLedgerDetails />,
      },
      {
        path: "quotes-orders",
        element: <QuotesOrdersPage />,
      },
      {
        path: "quotes-orders/:status",
        element: <QuotesAndOrdersDynamicPage />,
      },
      {
        path: "wip",
        element: <WipPage />,
      },
      {
        path: "wip/:categories",
        element: <WipDynamicPage />,
      },
      {
        path: "npd-orders",
        element: <NpdOrdersPage />,
      },
      {
        path: "service-request",
        element: <NpdOrdersPage />,
      },
      {
        path: "request-visit",
        element: <NpdOrdersPage />,
      },
    ],
  },

  //setting
  {
    path: "Setting",
    element: (
      <Provider store={store}>
        <ProtectedRoute>
          <PermissionsProvider>
            <GlobalProvider>
              <FilterProvider>
                <SortContextProvider>
                  <SettingProvider>
                    <SettingLayoutOne pageName="Setting" icon={<SettingIcon />} deIcon={<SettingIcon2 />} />,
                  </SettingProvider>
                </SortContextProvider>
              </FilterProvider>
            </GlobalProvider>
          </PermissionsProvider>
        </ProtectedRoute>
      </Provider>
    ),

    children: [
      {
        index: true,
        element: <Settings />,
      },
      {
        path: "main-activity",
        element: <MainActivity />,
      },
      {
        path: "orders",
        // element: <Orders />,
        children: [
          {
            index: true,
            element: <Orders />,
          },
          {
            path: ":orderId",
            element: <OrderDetails />,
          },
        ],
      },
      {
        path: "users",
        // element: <UsersScreen />,
        children: [
          {
            index: true,
            element: <UsersScreen />,
          },
          {
            path: "addUser",
            element: <CreateUserFrom />,
          },
          {
            path: "editUser/:id",
            element: <CreateUserFrom />,
          },
        ],
      },
      {
        path: "roles",
        // element: <RolePage />,
        children: [
          {
            index: true,
            element: <RolePage />,
          },
           // ,
          // {
          //   path: ":roleId",
          //   element: <RoleDetailPage />,
          // },
        ],
      },
      
      {
        path: "rights",
        element: <RightPage />,
      },
      {
        path: "New-rights",
        element: <NewRightsPage />,
      },
      {
        path: "profile",
        element: <h1 style={{ marginTop: "5rem" }}>Profile</h1>,
      },
      {
        path: "archives",
        children: [
          {
            index: true,
            element: <Archives />,
          },
          {
            path: "Sets",
            element: (
              <SortContextProvider>
                <SetArchives />
              </SortContextProvider>
            ),
          },
          {
            path: "Orders",
            element: <Orders />,
          },
          {
            path: "Catalog",
            element: <CatalogArchiveScreen />,
          },
          {
            path: "Catalog/:id",
            element: <CatalogProductArchiveScreen />,
          },
        ],
      },
      // {
      //   path: "limits",
      //   element: <LimitsPage />,
      // },
      {
        path: "limits",
        children: [
          {
            index: true,
            element: <LimitsPage />,
          },
          {
            path: ":limitType",
            element: <LimitsSubPage />,
          },
        ],
      },
      {
        path: "synchronize",
        children: [
          {
            index: true,
            element: <SyncPage />,
          },
          {
            path: ":actionType",
            element: <SyncActionTypePage />,
          },
        ],
      },
      {
        path: "missing-images",
        element: <MissingImages />,
      },
      {
        path: "restricted-designs",
        element: "",
        children: [
          {
            index: true,
            element: <RestrictedDesignCategoryPage />,
          },
          {
            path: ":category",
            element: <RestrictedDesignSubCategoryPage />,
          },
          {
            path: ":category/:subcategory",
            element: <RestrictProductPage />,
          },
        ],
      },
      {
        path: ":status",
        element: "",
        children: [
          {
            index: true,
            element: <DesignStatus />,
          },
          {
            path: ":designs",
            element: <Designs />,
          },
        ],
      },
      {
        path: "rate-master-rights",
        element: <RateMasterRights />,
      },
      {
        path: "waba-rights",
        element: <WabaRights />,
      },
      {
        path: "update-images",
        element: <UpdateImagesPage />,
      },
      {
        path: "labour-rights",
        element: <Labour_Rights />,
      },
      {
        path: "product-usp-and-gallery",
        element: <ProductUSPAndGallery />,
      },
      {
        path: "product-usp-and-gallery/add-uspDetails/:jewelCode",
        element: <AddUSPDetails />,
      },
      {
        path: "product-usp-and-gallery/edit-uspDetails/:jewelCode",
        element: <EditUSPDetails />,
      },
      {
        path: "my-binnys-access",
        element: "",
        children: [
          {
            index: true,
            element: <MyBinnysAccess />,
          },
          {
            path: ":clientId",
            element: <ClientsUserDetails />,
          },
          {
            path: "report/:clientId",
            element: <ClientReportPage />,
          },
        ],
      },
      {
        path: "stock-tray",
        element: <StockTray />,
      },
      {
        path: "event-type",
        element: <EventType />,
      },
      {
        path: "service-request",
        element: "",
        children: [
          {
            index: true,
            element: <ServiceRequest />,
          },
          {
            path: ":serviceRequestId",
            element: <ServiceRequestDetails />,
          },
        ],
      },
      // CORRECT POSITION: Melting Requests route at the same level as other Settings routes
      {
        path: "melting-requests",
        element: "",
        children: [
          {
            path: "", // This matches /Setting/melting-requests
            element: <MeltingRequests />,
          },
          {
            path: ":meltingRequestId", // This matches /Setting/melting-requests/:id
            element: <MeltingRequestDetail />,
          },
        ],
      },
      
    ],
  },

  {
    path: "*",
    element: <h1>NOT FOUND \ 404 \ </h1>,
  },
]);

export default router;
